const testingProfileMixin = {
    computed: {
        testingId() {
            return this.$route.params.id;
        }
    },
    methods: {
        fetchPositions( testId, filter = null ) {
            return this.axios.get( this.$config.urls.testing.fetchPositions.url.replace( ':id', testId ), { params: filter } )
                       .then( response => {
                           return response.data.data;
                       } ).catch(()=>{});
        },
        addPosition( testId, form ) {
            return this.axios.post( this.$config.urls.testing.addPosition.url.replace( ':id', testId ), form )
                       .then( () => {
                           this.snotifySuccess( 'saveSuccessMsg' );
                       } ).catch(()=>{});
        },
        fetchNrkPositions( testId, filter = null ) {
            return this.axios.get( this.$config.urls.testing.fetchNrkPositions.url.replace( ':id', testId ), { params: filter } )
                       .then( response => {
                           return response.data.data;
                       } ).catch(()=>{});
        },
        
        addResource( form ) {
            return this.axios.post( this.$config.urls.resource.addTest.url, form )
                       .then( () => {
                           this.snotifySuccess( 'saveSuccessMsg' );
                       } ).catch(()=>{});
        },
        
        removeResource( form ) {
            this.$snotify.confirm( this.getTranslation( 'deleteConfirmMsg' ), {
                showProgressBar: false,
                closeOnClick: false,
                backdrop: 0.5,
                buttons: [
                    {
                        text: this.getTranslation( 'yes' ), action: ( toast ) => {
                            return this.axios.post( this.$config.urls.resource.removeTest.url, form )
                                       .then( () => {
                                           this.$snotify.remove( toast.id );
                                
                                           this.fetchNrkPositions( this.testingId ).then( response => {
                                               this.items = response.items;
                                    
                                               this.filterForm.page = response.activePage;
                                    
                                               this.pagination.currentPage = response.activePage;
                                               this.pagination.total = response.totalItemsCount;
                                               this.pagination.lastPage = response.pages;
                                    
                                               this.$router.push( { query: { ...this.filterForm } } ).catch( () => {
                                               } );
                                           } ).catch(()=>{});
                                
                                           setTimeout( () => {
                                               this.snotifySuccess( 'deleteSuccessMsg' );
                                           } );
                                
                                
                                       } );
                        }, bold: true
                    },
                    { text: this.getTranslation( 'no' ), action: ( toast ) => this.$snotify.remove( toast.id ) }
                ]
            } );
        },
        
        removePosition( testId, form ) {
            this.$snotify.confirm( this.getTranslation( 'deleteConfirmMsg' ), {
                showProgressBar: false,
                closeOnClick: false,
                backdrop: 0.5,
                buttons: [
                    {
                        text: this.getTranslation( 'yes' ), action: ( toast ) => {
                            return this.axios.post( this.$config.urls.testing.removePosition.url.replace( ':id', testId ), form )
                                       .then( () => {
                                           this.$snotify.remove( toast.id );
                                
                                           this.fetchPositions( this.testingId ).then( response => {
                                               this.items = response.items;
                                    
                                               this.filterForm.page = response.activePage;
                                    
                                               this.pagination.currentPage = response.activePage;
                                               this.pagination.total = response.totalItemsCount;
                                               this.pagination.lastPage = response.pages;
                                    
                                               this.$router.push( { query: { ...this.filterForm } } ).catch( () => {
                                               } );
                                           } ).catch(()=>{});
                                
                                           setTimeout( () => {
                                               this.snotifySuccess( 'deleteSuccessMsg' );
                                           } );
                                
                                
                                       } );
                        }, bold: true
                    },
                    { text: this.getTranslation( 'no' ), action: ( toast ) => this.$snotify.remove( toast.id ) }
                ]
            } );
        },
        
        fetchPositionFormOptions() {
            return this.axios.get( this.$config.urls.testing.fetchPositionFormOptions.url )
                       .then( response => {
                           return response.data.data;
                       } ).catch(()=>{});
        }
    }
};

export default testingProfileMixin;
